import React from "react";
import { useParams, useLocation } from "react-router-dom";
import withApiErrorWrapper from "../HandleApiErrorWrapperNonRedux";
import AlertDetailsPageWrapper from "./AlertDetailsPageWrapper";

const WrappedWithErrorHandler = withApiErrorWrapper(AlertDetailsPageWrapper);

const AlertDetailsPageWithRouter = (props) => {
  const params = useParams();
  const location = useLocation();
  return (
    <WrappedWithErrorHandler
      {...props}
      match={{ params }}
      location={location}
    />
  );
};

export default AlertDetailsPageWithRouter;
